var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback } from 'react';
import SingleFilePicker from './SingleFilePicker';
export default function ImagePicker(props) {
    const { width, height, type, exact } = props;
    const transform = useCallback(function (file) {
        return __awaiter(this, void 0, void 0, function* () {
            const modalCropper = yield import('modal-cropper');
            const modalCropperFnc = modalCropper.default || modalCropper;
            return yield modalCropperFnc(file, width, height, type, exact);
        });
    }, [width, height, type, exact]);
    return React.createElement(SingleFilePicker, Object.assign({}, props, { transform: transform, accepts: "image/png, image/jpeg" }));
}
